import script from "./helper-need-rate-chart-controller.vue?vue&type=script&setup=true&lang=ts"
export * from "./helper-need-rate-chart-controller.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__